import { ModalService } from './modal.service'

const SERVICES = [
    ModalService
];

export {
    ModalService,
    SERVICES
};



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts